import React from 'react';
import { ArrowDown } from 'lucide-react';

// Lobster mascot animation
const LobsterMascot = () => (
  <svg viewBox="0 0 120 140" className="w-28 h-32 animate-float" fill="none">
    <ellipse cx="60" cy="85" rx="35" ry="45" fill="#ff3b3b" />
    <ellipse cx="60" cy="45" rx="25" ry="25" fill="#ff3b3b" />
    <circle cx="50" cy="40" r="6" fill="#0a0a0f" />
    <circle cx="70" cy="40" r="6" fill="#0a0a0f" />
    <circle cx="51" cy="38" r="2" fill="white" />
    <circle cx="71" cy="38" r="2" fill="white" />
    <path d="M45 25 Q35 10 25 15" stroke="#ff3b3b" strokeWidth="4" strokeLinecap="round" fill="none" />
    <path d="M75 25 Q85 10 95 15" stroke="#ff3b3b" strokeWidth="4" strokeLinecap="round" fill="none" />
    <circle cx="25" cy="15" r="4" fill="#ff3b3b" />
    <circle cx="95" cy="15" r="4" fill="#ff3b3b" />
    <ellipse cx="20" cy="80" rx="15" ry="10" fill="#ff3b3b" transform="rotate(-20 20 80)" />
    <ellipse cx="100" cy="80" rx="15" ry="10" fill="#ff3b3b" transform="rotate(20 100 80)" />
    <ellipse cx="60" cy="115" rx="20" ry="8" fill="#e63535" />
    <ellipse cx="60" cy="125" rx="16" ry="6" fill="#cc2f2f" />
    <ellipse cx="60" cy="133" rx="12" ry="5" fill="#b32929" />
  </svg>
);

const Hero = () => {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center pt-16 pb-20 px-6 relative z-10">
      {/* Mascot */}
      <div className="mb-8">
        <LobsterMascot />
      </div>

      {/* Title */}
      <h1 className="text-5xl sm:text-6xl lg:text-7xl font-display font-bold text-white mb-4 tracking-tight text-center">
        ClawdFactory
      </h1>
      
      {/* Tagline */}
      <p className="text-lg sm:text-xl text-[#ff3b3b] font-semibold uppercase tracking-widest mb-8 text-center">
        The autonomous meme factory.
      </p>

      {/* Description */}
      <p className="text-white/60 text-center max-w-xl mb-8 text-lg leading-relaxed">
        Creates meme coins, launches on Base, monitors markets, executes buybacks.
        <br />
        All autonomously. All on-chain. All verifiable.
      </p>

      {/* Badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
        <div className="px-4 py-2 glass-card text-white/80 text-sm">
          Token: <span className="text-[#ff3b3b] font-semibold">$CFACTORY</span>
        </div>
        <div className="px-4 py-2 glass-card text-white/80 text-sm">
          Network: <span className="text-[#ff3b3b] font-semibold">Base</span>
        </div>
        <div className="px-4 py-2 glass-card text-white/80 text-sm">
          Agent: <span className="text-[#ff3b3b] font-semibold">Clawd</span>
        </div>
      </div>

      {/* CTAs */}
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <a
          href="#live"
          className="px-8 py-4 bg-[#ff3b3b] text-white font-semibold rounded-xl hover:bg-[#e63535] transition-all hover:scale-105 shadow-lg shadow-[#ff3b3b]/20"
        >
          View Next Launch
        </a>
        <a
          href="#launches"
          className="px-8 py-4 glass-card text-white font-semibold rounded-xl hover:bg-white/10 transition-all"
        >
          See Recent Launches
        </a>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-6 h-6 text-white/30" />
      </div>
    </section>
  );
};

export default Hero;
